import Component from '../Component';
import React from 'react';
import {Select} from 'reactis-inputs';
import DbInfo from '../../dbinfo';
import immutable from 'immutable';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import TagInputBase from './TagInputBase';

export default class TagInput extends Component {

	constructor(){
		super();
		this.value = immutable.List();
	}

	renderInputGroup(children) {
		let addonBefore = this.props.addonBefore ? (
				<span className="input-group-addon" key="addonBefore">
        		{this.props.addonBefore}
      		</span>
			) : null;

		let addonAfter = this.props.addonAfter ? (
				<span className="input-group-addon" key="addonAfter">
      		  {this.props.addonAfter}
      		</span>
			) : null;

		let buttonBefore = this.props.buttonBefore ? (
				<span className="input-group-btn">
        		{this.props.buttonBefore}
      		</span>
			) : null;

		let buttonAfter = this.props.buttonAfter ? (
				<span className="input-group-btn">
        		{this.props.buttonAfter}
      		</span>
			) : null;

		let inputGroupClassName;
		switch (this.props.bsSize) {
			case 'small':
				inputGroupClassName = 'input-group-sm';
				break;
			case 'large':
				inputGroupClassName = 'input-group-lg';
				break;
			default:
		}

		const tooltip = this.props.help ? <Tooltip id={this.props.help}>{this.props.help}</Tooltip> : null;
		const help = this.props.help ? <span className="input-group-addon inputhelp" key="addonHelp">
						<OverlayTrigger placement='top' overlay={tooltip}><span className="fa fa-question-circle"></span></OverlayTrigger>
					</span> : null;


		if (this.props.loading) {
			buttonAfter = <span className="input-group-addon" style={{backgroundColor: '#FFF'}}>
        				<img src="/img/ajax-loader2.gif" />
      				</span>
		}
		return addonBefore || addonAfter || buttonBefore || help || buttonAfter ? (
				<div className={classNames(inputGroupClassName, 'input-group')} key="input-group">
					{addonBefore}
					{buttonBefore}
					{children}
					{addonAfter}
					{buttonAfter}
					{help}
				</div>
			) : children;
	}


	render() {
		return (
			this.renderInputGroup(<TagInputBase key="input" {...this.props} />)
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/TagInput.js